import { c as _c } from "react/compiler-runtime";
import { HeaderTitle, NavigationHeader } from '@onefootprint/idv2';
import { useTranslation } from 'react-i18next';
const InitError = () => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.initError"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <NavigationHeader leftButton={{
      variant: "close"
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp2);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <>{t1}<HeaderTitle title={t2} subtitle={t3} /></>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default InitError;
function _temp($) {
  return $.invalidConfigTitle;
}
function _temp2($_0) {
  return $_0.invalidConfigDescription;
}